import { Input } from "../ui/input"
import { CONST } from "@/constants"
interface DiscountPercentageInputProps extends React.ComponentProps<typeof Input> {
  onValueChange: (value: string) => void
}

export const DiscountPercentageInput = ({ onValueChange, ...props }: DiscountPercentageInputProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value.replace(/[^\d]/g, "")
    onValueChange(value)
  }

  const handleBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value.replace(/[^\d]/g, "")

    if (Number(value) < CONST.MIN_DISCOUNT) {
      value = CONST.MIN_DISCOUNT.toString()
    } else if (Number(value) > CONST.MAX_DISCOUNT) {
      value = CONST.MAX_DISCOUNT.toString()
    }

    onValueChange(value)
  }

  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
        <span className="text-gray-500">%</span>
      </div>
      <Input {...props} id="discount" placeholder="20" className="pl-7" onChange={handleChange} onBlur={handleBlur} />
    </div>
  )
}
